import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import "react-tabs/style/react-tabs.css";
import CustomTabs from "../../widgets/office/custom/CustomTabs";
import FilterContext from "../../routes/FilterContext";
import { connect } from "react-redux";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { Icon, latLngBounds } from "leaflet";
import "../../../node_modules/leaflet-draw/dist/leaflet.draw.css";
import { BodyAsFormData } from "../../services/utilities/util";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
import MarkerClusterGroup from "react-leaflet-markercluster";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
const position = [19.076, 72.8777];
class Custom2 extends React.Component {
  static contextType = FilterContext;
  state = {
    filters: {},
    customSummary: {},
    positionLat: 19.076,
    positionLong: 72.8777,
    leaseSummary: {},
    bounds: null,
    uniAddress: "",
  };

  componentDidMount() {
    let body = new FormData();
    body.append("path", window.location.pathname);
    body.append("action", "visited");
    if (window.location.search.includes("?")) {
      body.append("hash", window.location.search.split("?").pop());
    } else {
      body.append("hash", "");
    }

    apiMiddleware
      .post(process.env.REACT_APP_USER_ACTIVITY, body)
      .then((res) => {
        console.log(res);
      });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_custom_basic_details", BodyAsFormData(filters))
      .then((res) => {
        this.setState({
          customSummary: res.data,
        });
        if (
          res.data.location[0].latitude != "-" &&
          res.data.location[0].longitude != "-"
        ) {
          this.setState({
            positionLat: res.data.location[0].latitude,
            positionLong: res.data.location[0].longitude,
          });
          this.state.bounds = latLngBounds([
            res.data.location.latitude,
            res.data.location.longitude,
          ]);
          for (let i = 0; i < res.data.location.length; i++) {
            this.state.bounds.extend([
              res.data.location[i].latitude,
              res.data.location[i].longitude,
            ]);
          }
        }
      });

    apiMiddleware
      .post("api/edge/office/get_custom_lease_summary", BodyAsFormData(filters))
      .then((res) => {
        this.setState({
          leaseSummary: res.data,
        });
      });
    apiMiddleware
      .post(
        "api/edge/office/get_custom_units_and_rents",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState(
          { uniAddress: res.data.rent_details[0].unit_name },
          () => {}
        );
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_custom_basic_details",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({
            customSummary: res.data,
          });
          if (
            res.data.location[0].latitude != "-" &&
            res.data.location[0].longitude != "-"
          ) {
            this.setState({
              positionLat: res.data.location[0].latitude,
              positionLong: res.data.location[0].longitude,
            });
            this.state.bounds = latLngBounds([
              res.data.location.latitude,
              res.data.location.longitude,
            ]);
            for (let i = 0; i < res.data.location.length; i++) {
              this.state.bounds.extend([
                res.data.location[i].latitude,
                res.data.location[i].longitude,
              ]);
            }
          }
        });
      apiMiddleware
        .post(
          "api/edge/office/get_custom_lease_summary",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({
            leaseSummary: res.data,
          });
        });
      apiMiddleware
        .post(
          "api/edge/office/get_custom_units_and_rents",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState(
            { uniAddress: res.data.rent_details[0].unit_name },
            () => {}
          );
        });
    }
  }

  render() {
    return (
      <div className="container-fluid developer mapsPage customPage p-0">
        <div className="row">
          <div className="col-lg-4">
            <div className="widget widgetTransparent">
              <div className="row">
                <div
                  className="col-lg-12 aseetContent mapsUl "
                  style={{ backgroundColor: "#FFF", paddingTop: "15px" }}
                >
                  <h2>
                    {this.state.customSummary.heading}
                    <span className="online"></span>{" "}
                  </h2>
                  <ul className="descriptionUl mb-0">
                    <li>{this.state.customSummary.building}</li>
                    <li>{this.state.customSummary.micromarket}</li>
                    <li>{this.state.customSummary.grade}</li>
                  </ul>
                </div>
                <div className="col-12">
                  <div className="row bgWithPadding">
                    <div className="col-lg-12 p-0">
                      <img
                        src={this.state.customSummary.image}
                        height={"280px"}
                        width={"100%"}
                        style={{ marginBottom: "10px", objectFit: "cover" }}
                      />
                    </div>
                    {this.state.bounds != null && (
                      <div className="col-lg-12 p-0 customMapHeight">
                        <MapContainer
                          bounds={this.state.bounds}
                          scrollWheelZoom={true}
                        >
                          <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                          />
                          <MarkerClusterGroup>
                            {Object.keys(this.state.customSummary).length > 0 &&
                              this.state.customSummary.location.map(
                                (marker) => (
                                  <Marker
                                    position={[
                                      marker.latitude,
                                      marker.longitude,
                                    ]}
                                    icon={
                                      new Icon({
                                        iconUrl: markerIconPng,
                                        iconSize: [25, 41],
                                        iconAnchor: [12, 41],
                                      })
                                    }
                                  >
                                    <Popup>
                                      {[this.state.customSummary.heading]}
                                    </Popup>
                                  </Marker>
                                )
                              )}
                          </MarkerClusterGroup>
                        </MapContainer>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="widget customTabsDesign">
              <div className="col-lg-12 mapsTab p-0">
                <div className="row">
                  <CustomTabs
                    leaseSummary={this.state.leaseSummary}
                    address={this.state.uniAddress}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Custom2);
